import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useAPI } from '../../hooks/useAPI';
import { CorrectionData } from '../../types';
import { useAuth } from '../../contexts/AuthContext';
import { CorrectionModal } from './CorrectionModal';

interface EditCorrectionProps {
  refetchCorections: () => void;
}

export const EditCorrection = ({ refetchCorections }: EditCorrectionProps) => {
  const { correction_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [correction, setCorrection] = useState<CorrectionData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/corrections');
  };

  const handleSave = () => {
    navigate('/corrections');
    refetchCorections();
  };

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/corrections/${correction_id}`)
        .then(({ errors, data }) => {
          isLoading.current = false;
          setCorrection(data);
          setOpen(true);
        })
        .catch(error => {
          isLoading.current = false;
          console.log(error);
        });
    }
  }, [isAuthenticated, correction_id]);

  return (
    <Box className="edit-correction">
      <CorrectionModal
        open={open}
        handleClose={handleClose}
        handleSave={handleSave}
        correction={correction}
      />
    </Box>
  );
};
